import React from 'react';
import ReactHighcharts from 'react-highcharts';
import Constants from '../Constants';
/* eslint-disable */
export default class HighChart extends React.Component {
    constructor(props) {
        super(props);
        this.defaultConfig= {};
    }
    render() {
      return <ReactHighcharts config={this.props.config || Constants.HightChartsDefaultConfig} ref="chart" />;
    }
  }